import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './NotFound.css';

const NotFound = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="not-found-wrapper">
      <Helmet>
        <title>Page not found | Spiggl</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="body-not-found">
        <div className="not-found-content">
          <div className="page-icon">
            <img src='/logo2.png' alt="" />
          </div>
          
          <h1 className='not-found-header'>Page not found</h1>
          
          <p className='not-found-text'>This page doesn't exist or has been moved. Check the link, or head back home.</p>
          
          <a href="/" className="not-found-home-button">
            <span className="not-found-button-text">Back to Home</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
